module.exports = __webpack_public_path__ + "img/logo-light.b8794a07.png";